export default async(modul_id,actualRoom,settings) =>
{
    console.log('%c 🛫 Instant-LoginPW Module Loaded! ', 'background: #222; color: #bada55');
}
